module.exports = __webpack_public_path__ + "img/bg-5.51ffa6c3.jpg";